// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"b624048b","419":"55b76e15","439":"ead6b9ee","459":"34a32376","557":"01416445","774":"23cf0830","787":"5592bf64","814":"2d92b238","968":"fa98e7a0"}[chunkId] + ".chunk.js";
};